import styles from '../../maintenancerequestdetails.module.css';
import { Accordion, AccordionDetails, AccordionSummary, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { UploadCloud, X } from "react-feather";
import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-smart-toaster';
import { useAuth0 } from "@auth0/auth0-react";
import { AddLogCallAPI } from '../../../../components/AddLogs';
import { useForm } from 'react-hook-form';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import dayjs from 'dayjs';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";

const SummaryTab = ({ requestData, setRequestData, setSnackbarOpen, setSnackbarMsg, setLoading }) => {
    const { user, isAuthenticated } = useAuth0();
    const { getAccessTokenSilently } = useAuth0();
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const [deleteType, setDeleteType] = useState(0);
    const [requestImage, setRequestImage] = useState('/static/img/other.svg');
    const [oldData, setOldData] = useState({ description: '', resolution: '' });
    const [newData, setNewData] = useState({ description: '', resolution: '' });
    const [charsLeft, setCharsLeft] = useState({ description: 200, resolution: 200 });
    const [isUpdate, setIsUpdate] = useState(false);
    const [isUpdate2, setIsUpdate2] = useState(false);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(1);
    const [lightboxOpen2, setLightboxOpen2] = useState(false);
    const [lightboxIndex2, setLightboxIndex2] = useState(1);
    const [carouselImages, setCarouselImages] = useState([]);
    const [carouselImages2, setCarouselImages2] = useState([]);
    const [time, setTime] = useState(0);
    const [descVal, setDescVal] = useState('');
    const [isResolved, setIsResolved] = useState(false);
    const { handleSubmit, register, setValue } = useForm();
    const [taskExpanded, setTaskExpanded] = useState("panel1");
    const [inputValue, setInputValue] = useState("0:00");
    const [prevTime, setPrevTime] = useState(0);
    const [technicianList, setTechnicianList] = useState([]);
    const [prevTechnician, setPrevTechnician] = useState(0);
    const [selectedTechnician, setSelectedTechnician] = useState(0);
    const [prevScDate, setPrevScDate] = useState(null);
    const [prevScTime, setPrevScTime] = useState("");
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTime, setSelectedTime] = useState("");
    const [isReschedule, setIsReschedule] = useState(false);

    useEffect(() => {
        async function getAssigneeList() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios.get(process.env.REACT_APP_CASE_API_URL + "v1/technicians-new", {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                setTechnicianList(response.data.data);
            }).catch((error) => { });
        }
        getAssigneeList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        if (requestData) {
            setPrevTechnician(requestData?.technician_id);
            setSelectedTechnician(requestData?.technician_id);
            if (requestData?.schedule_date) {
                setPrevScDate(dayjs(requestData?.schedule_date));
                setSelectedDate(dayjs(requestData?.schedule_date));
            }
            setPrevScTime(requestData?.schedule_time);
            setSelectedTime(requestData?.schedule_time);
            if (requestData?.sub_category === 'Electrical Socket') {
                setRequestImage("/static/img/ElectricalSocket.svg");
            } else if (requestData?.sub_category === 'Light Switch/Dimmer') {
                setRequestImage("/static/img/Dimmer.svg");
            } else if (requestData?.sub_category === 'Mount Television') {
                setRequestImage("/static/img/tv.svg");
            } else if (requestData?.sub_category === 'Leak') {
                setRequestImage("/static/img/Leak.svg");
            } else if (requestData?.sub_category === 'Drain Clogged') {
                setRequestImage("/static/img/DrainClogged.svg");
            } else if (requestData?.sub_category === 'Water Temperature Issue') {
                setRequestImage("/static/img/WaterTemperature.svg");
            } else if (requestData?.sub_category === 'Heating & Cooling System') {
                setRequestImage("/static/img/heat&cool.svg");
            } else if (requestData?.sub_category === 'Stove/Oven Issue') {
                setRequestImage("/static/img/StoveOven.svg");
            } else if (requestData?.sub_category === 'Refrigerator Issue') {
                setRequestImage("/static/img/Refrigerator.svg");
            } else if (requestData?.sub_category === 'Washer/Dryer Issue') {
                setRequestImage("/static/img/Washer.svg");
            } else if (requestData?.sub_category === 'Other Issue') {
                setRequestImage("/static/img/other.svg");
            }

            setOldData({ description: requestData?.description, resolution: requestData?.resolution ? requestData?.resolution : '' });
            setNewData({ description: requestData?.description, resolution: requestData?.resolution ? requestData?.resolution : '' });

            setValue('description', requestData?.description);
            setValue('resolution', requestData?.resolution);

            if (requestData?.description?.length) {
                setCharsLeft(prev => {
                    return { ...prev, description: 200 - requestData?.description?.length };
                })
            }
            if (requestData?.resolution?.length) {
                setCharsLeft(prev => {
                    return { ...prev, resolution: 200 - requestData?.resolution?.length };
                })
            }

            let reqImages = requestData?.images?.map(i => {
                if (i?.file_path.split('.').pop() === 'jpeg' || i?.file_path.split('.').pop() === 'jpg' || i?.file_path.split('.').pop() === 'png' || i?.file_path.split('.').pop() === 'svg') {
                    return i;
                }
                return null;
            });

            reqImages = reqImages?.filter(i => i !== null);

            setCarouselImages(reqImages);

            let reqImages2 = requestData?.resolve_images?.map(i => {
                if (i?.file_path.split('.').pop() === 'jpeg' || i?.file_path.split('.').pop() === 'jpg' || i?.file_path.split('.').pop() === 'png' || i?.file_path.split('.').pop() === 'svg') {
                    return i;
                }
                return null;
            });

            reqImages2 = reqImages2?.filter(i => i !== null);

            setCarouselImages2(reqImages2);
        }
    }, [requestData, setValue]);

    useEffect(() => {
        if (oldData) {
            if (oldData?.description === newData?.description) {
                setIsUpdate(false);
            } else {
                setIsUpdate(true);
            }
        }
    }, [newData, oldData]);

    useEffect(() => {
        if (oldData) {
            if (oldData?.resolution === newData?.resolution) {
                setIsUpdate2(false);
            } else {
                setIsUpdate2(true);
            }
        }
    }, [newData, oldData]);

    const deleteConfirm = async () => {
        setLoading(true);
        setOpenDeleteModal(false);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.delete(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/' + deleteId, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setRequestData(prev => {
                if (deleteType === 1) {
                    let images = prev?.resolve_images?.filter(i => i?.id !== deleteId);
                    return { ...prev, resolve_images: images };
                } else {
                    let images = prev?.images?.filter(i => i?.id !== deleteId);
                    return { ...prev, images: images };
                }
            });
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const fileHandler = async (e) => {
        let extErr = false;
        let sizeErr = false;
        let files = e.target.files;
        let allowedExtensionArr = ".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf".split(',');

        if (files.length > 0) {
            if (allowedExtensionArr.length > 0) {
                let fileName = files[0].name;
                let fileSize = files[0].size;
                let fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
                fileNameExt = '.' + fileNameExt;

                if (allowedExtensionArr.indexOf(fileNameExt) === -1) {
                    extErr = true;
                }

                if (fileSize >= 5242880) {
                    sizeErr = true;
                }
            }
        }

        if (extErr) {
            toast.error("File type is not allowed.");
            return false;
        }

        if (sizeErr) {
            toast.error("File size should not be greater than 5 MB.");
            return false;
        }

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        setLoading(true);

        let formData = new FormData();
        formData.append("image", files[0]);

        axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/upload', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg('Files uploaded successfully.');

            setRequestData(prev => {
                let images = response.data.data.concat(prev?.images);
                return { ...prev, images: images };
            });
        }).catch(error => {
            setLoading(false);
        });
    }

    const fileHandler2 = async (e) => {
        let extErr = false;
        let sizeErr = false;
        let files = e.target.files;
        let allowedExtensionArr = ".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf".split(',');

        if (files.length > 0) {
            if (allowedExtensionArr.length > 0) {
                let fileName = files[0].name;
                let fileSize = files[0].size;
                let fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
                fileNameExt = '.' + fileNameExt;

                if (allowedExtensionArr.indexOf(fileNameExt) === -1) {
                    extErr = true;
                }

                if (fileSize >= 5242880) {
                    sizeErr = true;
                }
            }
        }

        if (extErr) {
            toast.error("File type is not allowed.");
            return false;
        }

        if (sizeErr) {
            toast.error("File size should not be greater than 5 MB.");
            return false;
        }

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        setLoading(true);

        let formData = new FormData();
        formData.append("image", files[0]);

        axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/resolve-files/upload', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg('Files uploaded successfully.');

            setRequestData(prev => {
                let images = response.data.data.concat(prev?.resolve_images);
                return { ...prev, resolve_images: images };
            });
        }).catch(error => {
            setLoading(false);
        });
    }

    const onUpdate = async (data) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests/" + requestData?.id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setRequestData(prev => {
                return { ...prev, description: response.data.data?.description, resolution: response.data.data?.resolution };
            });

            let logData = {
                title: "A maintenance request has been updated",
                description: [
                    "Name: " + response.data.data.title,
                    "Request number: " + response.data.data.request_no,
                    "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
                    "Tenant: " + response.data.data.tenant_name,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const onUpdate2 = async (data) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-new/" + requestData?.id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setRequestData(prev => {
                return { ...prev, description: response.data.data?.description, resolution: response.data.data?.resolution };
            });

            let logData = {
                title: "A maintenance request has been updated",
                description: [
                    "Name: " + response.data.data.title,
                    "Request number: " + response.data.data.request_no,
                    "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
                    "Tenant: " + response.data.data.tenant_name,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const updateTime = async (data) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-new/" + requestData?.id, { spent_time: time }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setRequestData(prev => {
                return { ...prev, spent_time: time };
            });

            let logData = {
                title: "A maintenance request has been updated",
                description: [
                    "Name: " + response.data.data.title,
                    "Request number: " + response.data.data.request_no,
                    "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
                    "Tenant: " + response.data.data.tenant_name,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const handleChange7 = (panel) => (event, isTaskExpanded) => {
        setTaskExpanded(isTaskExpanded ? panel : false);
    };

    useEffect(() => {
        if (requestData) {
            setDescVal(requestData?.resolution);
            if (requestData?.spent_time) {
                setTime(parseInt(requestData?.spent_time));
                setPrevTime(parseInt(requestData?.spent_time));
            }

            if (requestData?.current_status && (requestData?.current_status === 3 || requestData?.current_status === 5)) {
                setIsResolved(true);
            }
        }
    }, [requestData]);

    useEffect(() => {
        const handler = setTimeout(async () => {

            if (descVal !== '' && requestData?.id) {
                const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

                return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-new/" + requestData?.id, { resolution: descVal }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }).then((response) => {
                    setRequestData(prev => {
                        return { ...prev, resolution: response.data.data?.resolution };
                    });
                }).catch(() => { });
            }
        }, 1000);

        return () => {
            clearTimeout(handler);
        };
    }, [descVal, getAccessTokenSilently]);

    const formatTime = (mins) => {
        const hours = Math.floor(mins / 60);
        const minutes = mins % 60;
        return `${hours}:${minutes.toString().padStart(2, "0")}`;
    }

    useEffect(() => {
        setInputValue(formatTime(time));
    }, [time]);

    const parseTime = (value) => {
        if (!value) return 0;
        const digits = value.replace(/\D/g, "");
        if (digits.length <= 2) return parseInt(digits || "0", 10);
        const minutes = parseInt(digits.slice(-2), 10);
        const hours = parseInt(digits.slice(0, -2), 10);
        return hours * 60 + minutes;
    }

    const handleChange = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setInputValue(value);
        setTime(parseTime(value));
    }

    const chkChange = async (e) => {
        if (!requestData?.resolution && time === 0) {
            toast.error("Please add the resolution description and the time spent before resolving this request.");
            return false;
        } else if (!requestData?.resolution) {
            toast.error("Please add the resolution description before resolving this request.");
            return false;
        } else if (time === 0) {
            toast.error("Please add the time spent before resolving this request.");
            return false;
        }

        setIsResolved(e?.target?.checked);
        let current_status = 2;
        if (e?.target?.checked) {
            current_status = 5;
        }

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-resolve/" + requestData?.id, { current_status: current_status }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setRequestData(prev => {
                return { ...prev, current_status: current_status };
            });

            if (current_status === 3) {
                let logData = {
                    title: "A maintenance request has been solved",
                    description: [
                        "Name: " + response.data.data.title,
                        "Request number: " + response.data.data.request_no,
                        "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
                        "Tenant: " + response.data.data.tenant_name,
                        "Technician: " + response.data.data.technician_name,
                    ],
                };
                AddLogCallAPI(logData, token);
            }
        }).catch(() => { });
    }

    const assignTechnician = async () => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-assign/" + requestData?.id, { technician_id: selectedTechnician }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.data.technician_name + ' is now assigned to this request.');

            setRequestData(prev => {
                return { ...prev, technician_id: response.data.data.technician_id, technician_name: response.data.data.technician_name, current_status: 1 };
            });

            let logData = {
                title: "A technician has been assigned to request",
                description: [
                    "Name: " + response.data.data.title,
                    "Request number: " + response.data.data.request_no,
                    "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
                    "Tenant: " + response.data.data.tenant_name,
                    "Technician: " + response.data.data.technician_name,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const scheduleDateTime = async () => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-schedule/" + requestData?.id, { schedule_date: dayjs(selectedDate).format('YYYY-MM-DD'), schedule_time: selectedTime }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg('Maintenant request has been scheduled.');

            setRequestData(prev => {
                return { ...prev, schedule_date: response.data.data.schedule_date, schedule_time: response.data.data.schedule_time, current_status: 2 };
            });

            if (response.data.data.schedule_date) {
                setPrevScDate(dayjs(response.data.data.schedule_date));
                setSelectedDate(dayjs(response.data.data.schedule_date));
            }
            setPrevScTime(response.data.data.schedule_time);
            setSelectedTime(response.data.data.schedule_time);

            let logData = {
                title: "A maintenant request has been scheduled.",
                description: [
                    "Name: " + response.data.data.title,
                    "Request number: " + response.data.data.request_no,
                    "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
                    "Tenant: " + response.data.data.tenant_name,
                    "Technician: " + response.data.data.technician_name,
                    "Date/Time: " + dayjs(response.data.data.schedule_date).format('MM/DD/YYYY') + " - " + response.data.data.schedule_time,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const rescheduleDateTime = async () => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-reschedule/" + requestData?.id, { schedule_date: dayjs(selectedDate).format('YYYY-MM-DD'), schedule_time: selectedTime }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg('Maintenant request has been re-scheduled.');

            setRequestData(prev => {
                return { ...prev, schedule_date: response.data.data.schedule_date, schedule_time: response.data.data.schedule_time, current_status: 2 };
            });

            if (response.data.data.schedule_date) {
                setPrevScDate(dayjs(response.data.data.schedule_date));
                setSelectedDate(dayjs(response.data.data.schedule_date));
            }
            setPrevScTime(response.data.data.schedule_time);
            setSelectedTime(response.data.data.schedule_time);
            setIsReschedule(false);

            let logData = {
                title: "A maintenant request has been scheduled.",
                description: [
                    "Name: " + response.data.data.title,
                    "Request number: " + response.data.data.request_no,
                    "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
                    "Tenant: " + response.data.data.tenant_name,
                    "Technician: " + response.data.data.technician_name,
                    "Date/Time: " + dayjs(response.data.data.schedule_date).format('MM/DD/YYYY') + " - " + response.data.data.schedule_time,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<>
        <button className={`${styles.SummeryTitle}`}>
            <img src={requestImage} alt="" />
            {requestData?.title}
        </button>

        <div className="FormAccording ProspectTask Theme">
            <Accordion expanded={taskExpanded === "panel1"} onChange={handleChange7("panel1")}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                    <div className={`${styles.FormAccoHead}`}>
                        <p className={`${styles.FormAccoHeadTitle}`}>Request</p>
                    </div>
                </AccordionSummary>
                <AccordionDetails className={`${styles.CussAccoRow}`}>
                    {isAuthenticated && <>
                        <div className={`${styles.AssignTechSec} FormGroup`}>
                            <p className={`${styles.SummFormLabelTwo}`}>Technician Selection</p>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Select Technician *</InputLabel>
                                <Select
                                    label="Select Technician *"
                                    value={selectedTechnician ? selectedTechnician : ''}
                                    onChange={(e) => { setSelectedTechnician(e.target.value); }}
                                    disabled={!(user["https://propertydek.com/permissions"].indexOf("request-assigntechnician:read") > -1) || requestData?.current_status === 3 || requestData?.current_status === 4}
                                >
                                    {technicianList?.map(i => {
                                        return <MenuItem value={i?.value}>{i?.label}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                            {(selectedTechnician > 0 && prevTechnician !== selectedTechnician) && <button type='button' className={`${styles.SummaryUpdateBU}`} onClick={(e) => assignTechnician()}>Assign</button>}
                        </div>
                        {requestData?.current_status > 0 && <div className={`${styles.AssignTimeDateSec}`}>
                            <p className={`${styles.SummFormLabelTwo}`}>Date & Time Selection</p>
                            <div className={`${styles.AssignTimeDateSecUnder}`}>
                                <div className={`${styles.AssignTimeSec} FormGroup`}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Schedule Date *"
                                            value={selectedDate}
                                            onChange={(e) => { setSelectedDate(e); }}
                                            renderInput={(params) => (<TextField {...params} />)}
                                            disablePast
                                            disabled={!(user["https://propertydek.com/permissions"].indexOf("request-schedule:read") > -1) || (requestData?.current_status > 1 && !isReschedule)}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div className={`${styles.AssignDateSec} FormGroup`}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Select Time *</InputLabel>
                                        <Select
                                            label="Select Time *"
                                            value={selectedTime}
                                            onChange={(e) => { setSelectedTime(e.target.value); }}
                                            disabled={!(user["https://propertydek.com/permissions"].indexOf("request-schedule:read") > -1) || (requestData?.current_status > 1 && !isReschedule)}
                                        >
                                            <MenuItem value={"Morning (9AM - 12PM)"}>Morning (9AM - 12PM)</MenuItem>
                                            <MenuItem value={"Afternoon (12PM - 3PM)"}>Afternoon (12PM - 3PM)</MenuItem>
                                            <MenuItem value={"Evening (3PM - 6PM)"}>Evening (3PM - 6PM)</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                {user["https://propertydek.com/permissions"].indexOf("request-schedule:read") > -1 && <>
                                    {(selectedDate && selectedTime && (dayjs(prevScDate).format('YYYY-MM-DD') !== dayjs(selectedDate).format('YYYY-MM-DD') || prevScTime !== selectedTime)) && <button type='button' className={`${styles.SummaryUpdateBU}`} onClick={(e) => isReschedule ? rescheduleDateTime() : scheduleDateTime()}>Save</button>}
                                    {!isReschedule && requestData?.current_status === 2 && <button className={`${styles.AppoResBU}`} onClick={(e) => setIsReschedule(true)}>Reschedule Appointment</button>}
                                </>}
                            </div>
                        </div>}
                    </>}
                    <form onSubmit={handleSubmit(onUpdate)}>
                        <div className={`${styles.SummFormFull}`}>
                            <p className={`${styles.SummFormLabel}`}>Maintenance Issue Description</p>
                            <textarea name="description" ref={register} className={`${styles.formControlTextArea}`} maxLength={200} onChange={(e) => {
                                setCharsLeft(prev => {
                                    return { ...prev, description: 200 - e.target.value?.length };
                                });

                                setNewData(prev => {
                                    return { ...prev, description: e.target.value };
                                });
                            }} disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1)}></textarea>
                            <p className={`${styles.RemainingText}`}>{charsLeft?.description} {charsLeft?.description > 1 ? "characters" : "character"} remaining</p>
                        </div>
                        {isUpdate && <div>
                            <button type='submit' className={`${styles.SummaryUpdateBU}`}>Update</button>
                        </div>}
                    </form>
                    <div className={`${styles.BorderDivSumm}`}>
                        <p className={`${styles.SummFormLabel}`}>Request Photos</p>

                        <div className={`${styles.Row}`}>
                            {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1) && <div className={`${styles.FileUpDuBUDiv}`}>
                                <label className={`${styles.TakePhoteBU}`} for="file-upload"><UploadCloud /> Upload Photo</label>
                                <p className={`${styles.UploadTextNew}`}>File size upto 5 MB. JPEG, JPG, PNG only</p>
                                <input id="file-upload" type="file" onChange={fileHandler} accept={".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf"} />
                            </div>}
                            <div className={`${styles.ReqPhotoSec}`}>
                                {requestData?.images?.map((item, index) => {
                                    return (<div className={`${styles.SummFormSemiHalf}`}>
                                        {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1) && <button onClick={(e) => { setOpenDeleteModal(true); setDeleteId(item?.id); setDeleteType(0); }}><X /></button>}
                                        {((item?.file_path.split('.').pop() === 'doc' || item?.file_path.split('.').pop() === 'docx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                            <img src="/static/img/docIcon.png" alt='' />
                                            <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                                        </a> : ((item?.file_path.split('.').pop() === 'xls' || item?.file_path.split('.').pop() === 'xlsx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                            <img src="/static/img/excelIcon.png" alt='' />
                                            <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                                        </a> : ((item?.file_path.split('.').pop() === 'pdf') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                            <img src="/static/img/pdfIcon.png" alt='' />
                                            <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                                        </a> : <img src={item?.file_public_url} className={styles.UpIMG} alt="" onClick={(e) => { setLightboxOpen(true); setLightboxIndex(index); }} />)))}
                                    </div>)
                                })}
                            </div>
                            {requestData?.images?.length === 0 && (<div className={`${styles.NoImgDiv}`}>
                                <img src="/static/img/no-photo.png" alt="" />
                            </div>)}
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>

            {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-resolve:read")) > -1 && <Accordion expanded={taskExpanded === "panel2"} onChange={handleChange7("panel2")}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
                    <div className={`${styles.FormAccoHead}`}>
                        <p className={`${styles.FormAccoHeadTitle}`}>Resolution</p>
                    </div>
                </AccordionSummary>
                <AccordionDetails className={`${styles.CussAccoRow}`}>
                    <div className={`${styles.TimerSec}`}>
                        <label className={`${styles.FilterLabel}`}>Spent Time *</label>
                        <div className={`${styles.TimerFieldSec}`}>
                            <input type="text" value={inputValue} onChange={handleChange} className="time-input" placeholder="0:00" inputMode="numeric" />
                        </div>
                        <div className={`${styles.AddTimeSec}`}>
                            <button onClick={(e) => setTime((prev) => Math.max(0, prev + 15))} disabled={isResolved}>+0:15</button>
                            <button onClick={(e) => setTime((prev) => Math.max(0, prev + 60))} disabled={isResolved}>+1:00</button>
                            <button onClick={(e) => setTime((prev) => Math.max(0, prev + 30))} disabled={isResolved}>+0:30</button>
                            <button onClick={(e) => setTime((prev) => Math.max(0, prev + 120))} disabled={isResolved}>+2:00</button>
                        </div>
                        {prevTime !== time && <div>
                            <button type='button' className={`${styles.SummaryUpdateBU}`} onClick={(e) => updateTime()}>Update</button>
                        </div>}
                    </div>
                    <form onSubmit={handleSubmit(onUpdate2)}>
                        <div className={`${styles.SummFormFull}`}>
                            <p className={`${styles.SummFormLabel}`}>Resolution *</p>
                            <textarea name="resolution" ref={register} className={`${styles.formControlTextArea}`} maxLength={200} onChange={(e) => {
                                setCharsLeft(prev => {
                                    return { ...prev, resolution: 200 - e.target.value?.length };
                                });

                                setNewData(prev => {
                                    return { ...prev, resolution: e.target.value };
                                });
                            }}></textarea>
                            <p className={`${styles.RemainingText}`}>{charsLeft?.resolution} {charsLeft?.resolution > 1 ? "characters" : "character"} remaining</p>
                        </div>
                        {isUpdate2 && <div>
                            <button type='submit' className={`${styles.SummaryUpdateBU}`}>Update</button>
                        </div>}
                    </form>
                    <div className={`${styles.BorderDivSumm}`}>
                        <p className={`${styles.SummFormLabel}`}>Resolution Photos</p>

                        <div className={`${styles.Row}`}>
                            <div className={`${styles.FileUpDuBUDiv}`}>
                                <label className={`${styles.TakePhoteBU}`} for="file-upload2"><UploadCloud /> Upload Photo</label>
                                <p className={`${styles.UploadTextNew}`}>File size upto 5 MB. JPEG, JPG, PNG only</p>
                                <input id="file-upload2" type="file" onChange={fileHandler2} accept={".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf"} />
                            </div>
                            <div className={`${styles.ReqPhotoSec}`}>
                                {requestData?.resolve_images?.map((item, index) => {
                                    return (<div className={`${styles.SummFormSemiHalf}`}>
                                        <button onClick={(e) => { setOpenDeleteModal(true); setDeleteId(item?.id); setDeleteType(1); }}><X /></button>
                                        {((item?.file_path.split('.').pop() === 'doc' || item?.file_path.split('.').pop() === 'docx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                            <img src="/static/img/docIcon.png" alt='' />
                                            <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                                        </a> : ((item?.file_path.split('.').pop() === 'xls' || item?.file_path.split('.').pop() === 'xlsx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                            <img src="/static/img/excelIcon.png" alt='' />
                                            <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                                        </a> : ((item?.file_path.split('.').pop() === 'pdf') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                            <img src="/static/img/pdfIcon.png" alt='' />
                                            <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                                        </a> : <img src={item?.file_public_url} alt="" onClick={(e) => { setLightboxOpen2(true); setLightboxIndex2(index); }} />)))}

                                    </div>)
                                })}
                            </div>

                        </div>
                    </div>
                    <div className={`${styles.FormGroupFull} FormGroup checkbox`}>
                        <FormControlLabel control={<Checkbox checked={isResolved} onChange={(e) => chkChange(e)} />} label="Mark as Resolved" />
                    </div>
                </AccordionDetails>
            </Accordion>}
        </div >

        <Dialog
            open={openDeleteModal}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setOpenDeleteModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">Are you sure you want to delete the image?<button onClick={(e) => setOpenDeleteModal(false)}><X /></button></DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">The image will be removed immediately.You can't undo this action.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className="CancelPopupBU" onClick={(e) => deleteConfirm()}>Delete</Button>
                <Button className="SubmitPopupBU" onClick={(e) => setOpenDeleteModal(false)}>Cancel</Button>
            </DialogActions>
        </Dialog>

        <Lightbox
            open={lightboxOpen}
            close={() => setLightboxOpen(false)}
            index={lightboxIndex}
            carousel={{ finite: true, preload: 2, padding: "16px", spacing: "30%", imageFit: "contain" }}
            slides={carouselImages?.map(i => {
                if (i?.file_path.split('.').pop() === 'jpeg' || i?.file_path.split('.').pop() === 'jpg' || i?.file_path.split('.').pop() === 'png' || i?.file_path.split('.').pop() === 'svg') {
                    return { src: i?.file_public_url };
                }
                return null;
            })}
        />

        <Lightbox
            open={lightboxOpen2}
            close={() => setLightboxOpen2(false)}
            index={lightboxIndex2}
            carousel={{ finite: true, preload: 2, padding: "16px", spacing: "30%", imageFit: "contain" }}
            slides={carouselImages2?.map(i => {
                return { src: i?.file_public_url };
            })}
        />
    </>);
}

export default SummaryTab;